export const watermarkId = 'MIP-watermark';
const addWatermarkComponentStyles = (waterMarkDiv, labelAction) => {
    waterMarkDiv.style.position = 'absolute';
    waterMarkDiv.style.fontSize = `${labelAction.fontSize}px`;
    waterMarkDiv.style.zIndex = '10';
    waterMarkDiv.style.top = '40%';
    waterMarkDiv.style.left = '40%';
    waterMarkDiv.style.opacity = '100%';
    waterMarkDiv.style.webkitTextStrokeWidth = '0.5px';
    waterMarkDiv.style.webkitTextStrokeColor = `var(--ms-themeColorPaletteNeutralSecondary, #605e5c)`;
    // Color can be #RRGGBB[AA], FontCOlor already has #RRGGBB so appending AA@0.25
    waterMarkDiv.style.webkitTextFillColor = `${labelAction.fontColor}40`;
    waterMarkDiv.style.transform = `rotate(${labelAction.layout.toLowerCase() === 'diagonal' ? '-12deg' : '0deg'})`;
    waterMarkDiv.style.fontWeight = 'bold';
    waterMarkDiv.style.textAlign = 'center';
};
const getWatermarkComponent = (doc, labelAction) => {
    const watermarkDiv = doc.createElement('div');
    addWatermarkComponentStyles(watermarkDiv, labelAction);
    watermarkDiv.id = watermarkId;
    watermarkDiv.innerText = labelAction.text;
    return watermarkDiv;
};
export function applyWatermark(componentDivSync, informationProtectionService, resolvedUrl, mipCache, tracker) {
    tracker?.markSubActivityStart('ApplyWatermark');
    const removeExistingWatermark = () => {
        let watermarkElement = undefined;
        for (const e of componentDivSync.children) {
            if (e.id === watermarkId) {
                watermarkElement = e;
            }
        }
        if (watermarkElement) {
            componentDivSync.removeChild(watermarkElement);
        }
    };
    const onWatermarkChanged = (watermarkProps) => {
        removeExistingWatermark();
        if (watermarkProps) {
            const doc = componentDivSync.ownerDocument;
            const watermarkDiv = getWatermarkComponent(doc, watermarkProps);
            componentDivSync.appendChild(watermarkDiv);
        }
    };
    // Update the watermark from cache if available
    if (mipCache?.watermark) {
        onWatermarkChanged(mipCache.watermark);
    }
    informationProtectionService.on('watermarkingChanged', onWatermarkChanged);
    informationProtectionService
        .getWatermarkInformation(resolvedUrl)
        .then((watermark) => {
        onWatermarkChanged(watermark);
    })
        .catch(() => { });
    tracker?.markSubActivityEnd('ApplyWatermark');
}
//# sourceMappingURL=applyWatermark.js.map